import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds timeout
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only handle 401 errors (authentication errors)
    // Don't handle timeouts, network errors, or other errors here
    if (error.response?.status === 401) {
      // Don't redirect on login endpoint - that's a normal error response
      const isLoginEndpoint = error.config?.url?.includes('/auth/login');
      const isOnLoginPage = window.location.pathname === '/login';
      
      if (!isLoginEndpoint && !isOnLoginPage) {
        // Token expired or invalid - only redirect if not on login page and not calling login endpoint
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        
        // Only redirect if we're not already on the login page
        window.location.href = '/login';
      }
      // If we're already on login page or calling login endpoint, just let the error through
    }
    // For 403 errors (forbidden), log but don't show error to user if it's a student-only endpoint
    // This prevents errors when teachers access pages that might try to call student endpoints
    if (error.response?.status === 403) {
      const isStudentEndpoint = error.config?.url?.includes('/student/');
      if (isStudentEndpoint) {
        // Silently ignore 403 errors for student endpoints when user is not a student
        // The calling component should handle this gracefully
        console.debug('403 Forbidden for student endpoint (expected for non-students):', error.config?.url);
      }
    }
    // For all other errors (timeouts, network errors, etc.), just reject the promise
    // Let the calling code handle the error appropriately
    return Promise.reject(error);
  }
);

export default api;









